import { defineMessages } from 'react-intl';

export default defineMessages({
	buttonLabel: {
		id: 'components.reports.reportsPageContent.Offcb.transactionsDetailsModal.buttonLabel',
		defaultMessage: 'بستن',
	},
});
